import React, { useMemo, useState } from 'react';
import { FormControl, InputLabel, OutlinedInput } from '@mui/material';
import { useIntl } from 'react-intl';
import IntlMessages from 'Util/IntlMessages';
import { PatternFormat } from 'react-number-format';
import { BUSINESS_NUMBER_NOT_VALID, joinError } from 'Api/Errors';
import { useSelector } from 'react-redux';

const VerificationBusinessNumberInput = ({
  value,
  onValueChange,
  label,
  placeholder: propsPlaceholder,
  isError = false,
  errorText,
  isShowPlaceholder = false,
  maxLength,
  tabIndex = 0,
  isValidNumber,
  handleCheckBusinessNumber,
  hasClicked,
  ...props
}) => {
  const { formatMessage } = useIntl();
  const [isFocus, setIsFocus] = useState(false);
  const placeholder = useMemo(() => {
    if (propsPlaceholder === undefined) return label;
    if (isShowPlaceholder) return propsPlaceholder;
    if (!isFocus) return label;
    return propsPlaceholder;
  }, [isFocus, label, propsPlaceholder, isShowPlaceholder]);
  const { isLoading } = useSelector(state => state.loading);

  return (
    <FormControl
      error={isError}
      fullWidth
      variant="outlined"
      sx={{
        '& label': {
          color: '#000',
          fontFamily: 'Pretendard',
        },
        '& label.Mui-focused': {
          color: '#000',
        },
        '& label.Mui-error': {
          color: '#000',
        },

        '& .MuiOutlinedInput-root': {
          fieldset: {
            borderRadius: '10px',
            border: '1px solid #ddd',
          },
          '&:hover fieldset': {
            borderColor: '#000',
          },
          '&.Mui-focused fieldset': {
            border: '1px solid #000',
          },
          '&.Mui-error fieldset': {
            border: '1px solid #FF4B4B',
          },
        },
      }}
    >
      {(isFocus || value) && <InputLabel htmlFor={label}>{formatMessage({ id: label })}</InputLabel>}
      <PatternFormat
        id={label}
        value={value}
        onValueChange={onValueChange}
        format="###-##-#####"
        type={'text'}
        placeholder={formatMessage({ id: placeholder })}
        label={formatMessage({ id: label })}
        onFocus={() => {
          setIsFocus(true);
        }}
        onBlur={e => {
          if (!e?.relatedTarget?.className?.includes('business-number-check-button') && !e?.relatedTarget?.closest('.business-number-check-button')) {
            setIsFocus(false);
          }
        }}
        customInput={OutlinedInput}
        inputProps={{
          style: {
            color: '#222',
            fontFamily: 'Pretendard',
            fontSize: '15px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: 'normal',
            padding: '15px',
          },
          tabIndex,
        }}
        endAdornment={
          <div
            className="business-number-check-button cursor-pointer no-drag"
            style={{ padding: '8px 10px', borderRadius: '8px', backgroundColor: '#E6F0FD', color: '#0567f9', fontSize: '13px', fontWeight: 400, lineHeight: 'normal', whiteSpace: 'nowrap' }}
            onMouseDown={e => {
              e.preventDefault();
            }}
            onClick={handleCheckBusinessNumber}
          >
            <IntlMessages id="signIn.join.referral.check" />
          </div>
        }
        onKeyPress={e => {
          if (e.key === 'Enter') {
            handleCheckBusinessNumber();
          }
        }}
        {...props}
      />
      {isError && errorText && !isValidNumber && <div className="error-text">{errorText}</div>}
      {!isLoading && !isFocus && !isError && !isValidNumber && (
        <div className="error-text">
          <IntlMessages id={joinError[BUSINESS_NUMBER_NOT_VALID]} />
        </div>
      )}
      {isValidNumber && (
        <div className="focus-text">
          <IntlMessages id="signIn.join.referral.check.message" />
        </div>
      )}
    </FormControl>
  );
};

export default VerificationBusinessNumberInput;
